import PropTypes from 'prop-types'
import React from 'react'

import ItemCard from '.'

function OrderItemCard({
  item,
  index,
  length,
  showPrice,
  handleChangeItemQuantity,
  handleRemoveItem,
}) {
  const imageSrc = item.imageUrl || item.ean
  return (
    <ItemCard
      index={index}
      length={length}
      showPrice={showPrice}
      skuSpecifications={item.skuSpecifications}
      imageSrc={imageSrc}
      productName={item.name}
      value={item.sellingPrice * item.quantity}
      orderItemInconsistency={item.orderItemInconsistency}
      handleChangeItemQuantity={handleChangeItemQuantity}
      handleRemoveItem={handleRemoveItem}
      ean={item.ean}
      itemQuantity={item.quantity}
    />
  )
}

OrderItemCard.propTypes = {
  item: PropTypes.object.isRequired,
  maxQuantity: PropTypes.number,
  index: PropTypes.number,
  length: PropTypes.number,
  handleChangeItemQuantity: PropTypes.func,
  handleRemoveItem: PropTypes.func,
  showPrice: PropTypes.bool,
}

export default OrderItemCard
